import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import * as serviceWorker from '../serviceWorker';
import { Loading } from '../components/Loading';
import { Toggle } from '../components/Toggle';

const db = firebase.firestore();

const checkDarkMode = (color1, color2) => {
  document
    .querySelector('body')
    .style.setProperty('--theme-primary-color', color1);
  document
    .querySelector('body')
    .style.setProperty('--theme-secondary-color', color2);
};

export function Profile() {
  const { user } = useAuthState(firebase.auth());
  const [loading, setLoading] = useState(true);
  const [aislesRollout, setAislesRollout] = useState();
  const [scheduleRollout, setScheduleRollout] = useState();
  const [isChecked, setChecked] = useState({
    darkMode: false,
    appUpdatesNotes: false,
    marketingNotes: false,
    scheduleTab: false,
    aislePrediction: false
  });
  const [value, setValue] = useState({
    autoArchive: 7
  });

  const handleChange = async e => {
    setValue({ ...value, [e.target.name]: e.target.value });
    const valueName = e.target.name;
    const valueValue = e.target.value;

    try {
      const userDoc = await db
        .collection('users')
        .doc(user.uid)
        .get();
      const { preferences } = await userDoc.data();

      await db
        .collection('users')
        .doc(user.uid)
        .update({
          preferences: {
            ...preferences,
            [valueName]: valueValue
          }
        });
    } catch ({ message }) {
      console.log(message);
    }
  };

  const handleChecked = async e => {
    setChecked({ ...isChecked, [e.target.name]: !isChecked[e.target.name] });
    const checkedName = e.target.name;

    if (checkedName === 'darkMode' && !isChecked[e.target.name] === true) {
      localStorage.setItem('darkMode', true);
      checkDarkMode('black', 'white');
    } else {
      localStorage.setItem('darkMode', false);
      checkDarkMode('white', 'black');
    }

    try {
      const userDoc = await db
        .collection('users')
        .doc(user.uid)
        .get();
      const { preferences } = await userDoc.data();

      await db
        .collection('users')
        .doc(user.uid)
        .update({
          preferences: {
            ...preferences,
            [checkedName]: !isChecked[checkedName]
          }
        });
    } catch ({ message }) {
      console.log(message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const aislesRollout = await db
          .collection('rollouts')
          .doc('aislesFeature')
          .get();

        if (aislesRollout) {
          setAislesRollout({
            id: aislesRollout.id,
            ...aislesRollout.data()
          });
        }

        const scheduleRollout = await db
          .collection('rollouts')
          .doc('scheduleFeature')
          .get();

        if (scheduleRollout) {
          setScheduleRollout({
            id: scheduleRollout.id,
            ...scheduleRollout.data()
          });
        }

        const userDoc = await db
          .collection('users')
          .doc(user.uid)
          .get();
        const { preferences } = await userDoc.data();
        const {
          darkMode,
          appUpdatesNotes,
          marketingNotes,
          scheduleTab,
          aislePrediction,
          autoArchive
        } = preferences;

        setChecked({
          darkMode: darkMode || false,
          appUpdatesNotes: appUpdatesNotes || false,
          marketingNotes: marketingNotes || false,
          scheduleTab: scheduleTab || false,
          aislePrediction: aislePrediction || false
        });

        setValue({
          autoArchive
        });

        if (preferences && darkMode === true) {
          localStorage.setItem('darkMode', true);
        } else {
          localStorage.setItem('darkMode', false);
        }

        setLoading(false);
      } catch ({ message }) {
        setLoading(false);
        console.log(message);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading && <Loading />}
      {!loading && (
        <>
          <Header>Profile</Header>
          <>
            <HeaderSmaller>Preferences</HeaderSmaller>
            <form onSubmit={e => e.preventDefault()}>
              <FormGroup>
                <label>When do you want auto archive lists?</label>
                <Flex>
                  <Slider
                    type="range"
                    min="1"
                    max="31"
                    value={value && value.autoArchive}
                    onChange={e => handleChange(e)}
                    name="autoArchive"
                  />
                  <p>
                    {value && value.autoArchive === '1'
                      ? `${value && value.autoArchive} day`
                      : `${value && value.autoArchive} days`}
                  </p>
                </Flex>
              </FormGroup>
              <Toggle
                isChecked={isChecked.darkMode}
                label="Dark Mode"
                setChecked={e => handleChecked(e)}
                name="darkMode"
              />
              <HeaderSmallest>Push Notifications</HeaderSmallest>
              <Toggle
                isChecked={isChecked.appUpdatesNotes}
                label="App Updates"
                setChecked={e => handleChecked(e)}
                name="appUpdatesNotes"
              />
              <Toggle
                isChecked={isChecked.marketingNotes}
                label="Marketing"
                setChecked={e => handleChecked(e)}
                name="marketingNotes"
              />
            </form>
          </>
          <>
            {(scheduleRollout && scheduleRollout.isActive) ||
              (aislesRollout && aislesRollout.isActive === true && (
                <HeaderSmaller>Experimental features</HeaderSmaller>
              ))}
            {scheduleRollout && scheduleRollout.isActive === true && (
              <Toggle
                isChecked={isChecked.scheduleTab}
                label="Schedule Tab"
                setChecked={e => handleChecked(e)}
                name="scheduleTab"
              />
            )}

            {aislesRollout && aislesRollout.isActive === true && (
              <Toggle
                isChecked={isChecked.aislePrediction}
                label="Aisle prediction"
                setChecked={e => handleChecked(e)}
                name="aislePrediction"
              />
            )}
          </>
          <>
            <HeaderSmaller style={{ marginTop: 40 }}>
              Account actions
            </HeaderSmaller>
            <AccountList>
              <li>
                <Link to="/invite">Invite a friend!</Link>
              </li>
              <li>
                <Link to="/account/reset/password">Reset your password</Link>
              </li>
              <li>
                <Link to="/account/reset/email">Change your email</Link>
              </li>
              <li>
                <Link to="/account/reset/photo">Change your photo</Link>
              </li>
            </AccountList>
            <CacheClear
              onClick={() => {
                serviceWorker.unregister();
                window.location.reload(true);
              }}
            >
              Clear cache
            </CacheClear>
          </>
        </>
      )}
    </>
  );
}

const Flex = styled.div`
  display: flex;

  p {
    flex-basis: 20%;
    padding: 0;
    margin-top: 3px;
    margin-left: 20px;
    background-color: var(--theme-secondary-color);
    color: var(--theme-primary-color);
    padding: 7px;
    font-size: 13px;
    border-radius: 4px;
    text-align: center;
  }
`;

const Slider = styled.input`
  appearance: none;
  flex-basis: 80%;
  height: 30px;
  background: #d3d3d3;
  outline: none;
  transition: opacity 0.2s;
  border-radius: 4px;
  padding: 0px 5px;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 100px;
    background: var(--theme-primary-color);
    cursor: pointer;
  }

  &:-moz-range-thumb {
    width: 25px;
    height: 25px;
    background: #4caf50;
    cursor: pointer;
  }
`;

const Header = styled.h2`
  font-family: sans-serif;
  margin-bottom: 30px;
`;

const HeaderSmaller = styled.h3`
  font-family: sans-serif;
  margin-bottom: 30px;
`;

const HeaderSmallest = styled.h5`
  font-family: sans-serif;
  margin-top: 40px;
`;

const AccountList = styled.ul`
  font-family: sans-serif;
  list-style-type: none;
  padding: 0;

  a {
    display: block;
    background-color: var(--theme-primary-color);
    max-width: 100%;
    padding: 20px;
    border-radius: 24px;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
    color: var(--theme-secondary-color);
    text-decoration: none;
    font-weight: bold;
  }

  li {
    &:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

const FormGroup = styled.div`
  font-family: sans-serif;
  margin-bottom: 20px;

  label {
    margin-bottom: 10px;
  }

  input,
  label {
    display: block;
  }
`;

const CacheClear = styled.button`
  background-color: transparent;
  border: none;
  text-align: center;
  margin-top: 20px;
`;
